<template>
  <v-app>
    <v-app-bar app color="white" height="50">
      <img src="../public/2.png" width="80px" style="margin-top: 20px;" />
      <div id="header1">SHAMAL KUMAR</div>
    </v-app-bar>

    <v-main>
      <section id="hero">
        <v-row no-gutters>
          <v-img
            :max-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
            :min-height="'calc(65vh - ' + $vuetify.application.top + 'px)'"
            src="https://images.unsplash.com/photo-1593062096033-9a26b09da705?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80"
          >
            <v-theme-provider dark>
              <v-container fill-height>
                <v-row
                  align="center"
                  class="white--text mx-auto"
                  justify="center"
                >
                  <v-col class="white--text text-center" cols="12" tag="h1">
                    <span
                      class="font-weight-black"
                      :class="[
                        $vuetify.breakpoint.smAndDown
                          ? 'display-1'
                          : 'display-2',
                      ]"
                    >
                      <br />
                      <span style="color:white"> Hi, I am </span> <br />
                      <span style="color: #ffd60a">Shamal Kumar</span>
                      <br />
                    </span>

                    <br />

                    <span
                      style="color:white"
                      :class="[
                        $vuetify.breakpoint.smAndDown
                          ? 'display-1'
                          : 'display-1',
                      ]"
                      class="font-weight-light"
                      >I am a Freelance Developer</span
                    >
                  </v-col>

                  <v-btn
                    class="align-self-end"
                    fab
                    outlined
                    @click="$vuetify.goTo('#about-me')"
                  >
                    <v-icon>mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-theme-provider>
          </v-img>
        </v-row>
      </section>
      <!--
      <div class="powr-instagram-feed" id="f52393b8_1599766454"></div>
-->
      <section id="about-me">
        <div class="py-1"></div>

        <v-container class="text-center">
          <h2 class="mb-3">ABOUT ME</h2>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >
            <span style="font-size: 20px; font-family: Jost; font-weight:400;">
              Freelance Developer, committed to providing you with the highest
              quality services, such as custom website design, web development,
              SEO optimization, e-commerce solutions, content management systems
              and digital marketing. My goal is to ensure your online presence
              is successful, and I strive to help you reach your business
              objectives.
              <span
                @click="$vuetify.goTo('#contact')"
                style="color:#02c39a;font-weight:bold;cursor: pointer;"
                >Contact me</span
              >
              today to get started on your project!</span
            >
          </v-responsive>

          <!--    -->

          <v-avatar class="elevation-12 mb-12" size="180">
            <v-img src="./assets/IMG_5391 2.webp" height="180px"></v-img>
          </v-avatar>

          <div></div>

          <v-btn
            class="align-self-end"
            fab
            outlined
            color="white"
            @click="$vuetify.goTo('#resume')"
          >
            <v-icon>mdi-chevron-double-down</v-icon>
          </v-btn>
          <!-- 

          <v-btn
            color="grey"
            href="https://vuetifyjs.com"
            outlined
            large
          >
            <span class="grey--text text--darken-1 font-weight-bold">
              Vuetify Documentation
            </span>
          </v-btn>
          -->
        </v-container>

        <div class="py-1"></div>
      </section>

      <section id="resume" class="grey lighten-3">
        <div class="py-1"></div>

        <v-container class="text-center">
          <h2 class="mb-3">RESUME</h2>

          <v-card class="py-12 px-4" color="grey lighten-5" flat>
            <v-theme-provider dark>
              <div>
                <span
                  :class="[
                    $vuetify.breakpoint.smAndDown ? 'display-1' : 'display-1',
                  ]"
                  class="font-weight-light"
                  >Education</span
                >
                <br />
                <span max-width="720" style="font-size: 26px; font-weight: bold"
                  >Federation University Australia</span
                >
                <br />
                <span style="font-size: 24px">Australia</span>
                <br />
                <span style="font-size: 20px">Master of Technology</span>
                <br />
                <span style="font-size: 18px; color: blue">2018</span>
                <br />
                <span style="font-size: 16px; color: grey"
                  >Majoring in Enterprise Systems</span
                >
                <br />
                <br />
                <span max-width="720" style="font-size: 26px; font-weight: bold"
                  >University Of The South Pacific</span
                >
                <br />
                <span style="font-size: 24px">Fiji</span>
                <br />
                <span style="font-size: 20px">Bachelor of Science</span>
                <br />
                <span style="font-size: 18px; color: blue">2015</span>
                <br />
                <span style="font-size: 16px; color: grey"
                  >Majoring in Computing Science and Information System</span
                >
                <br />
                <br />
                <v-divider light></v-divider>
                <br />
                <span
                  :class="[
                    $vuetify.breakpoint.smAndDown ? 'display-1' : 'display-1',
                  ]"
                  class="font-weight-light"
                  >Professional Membership</span
                >
                <br />
                <span max-width="720" style="font-size: 26px; font-weight: bold"
                  >Golden Key International Honour Society</span
                >
                <br />
                <span style="font-size: 18px; color: blue">2018</span>
                <br />
              </div>
            </v-theme-provider>
            <br />
            <br />
            <v-btn
              class="align-self-end"
              fab
              outlined
              @click="$vuetify.goTo('#workwith')"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </v-card>
        </v-container>

        <div class="py-1"></div>
      </section>

      <section id="workwith">
        <div class="py-1"></div>
        <h2 class="mb-3" align="center">
          I WORK WITH
        </h2>
        <v-parallax
          :height="$vuetify.breakpoint.smAndDown ? 1150 : 800"
          src="https://images.unsplash.com/photo-1579403124614-197f69d8187b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80"
        >
          <v-card color="rgb(0, 0, 0, 0.2)" align="center" justify="center">
            <br />
            <br />
            <br />
            <v-container>
              <v-row>
                <v-flex xs6 sm3 md3>
                  <v-img
                    style="margin-top: 5px"
                    width="100px"
                    src="./assets/js.png"
                  ></v-img>
                  <br />
                  <p style="font-size: 20px; color: white; margin-top: 5px">
                    JavaScript
                  </p>
                </v-flex>
                <v-flex xs6 sm3 md3>
                  <v-img
                    style="margin-top: 5px"
                    width="150px"
                    height="100px"
                    src="./assets/node2.png"
                  ></v-img>
                  <br />
                  <p style="font-size: 20px; color: white; margin-top: 5px">
                    Node.Js
                  </p>
                </v-flex>
                <v-flex xs6 sm3 md3>
                  <v-img
                    width="110px"
                    src="./assets/vue.png"
                    style="margin-top: 0px"
                  ></v-img>
                  <p style="font-size: 20px; color: white; margin-top: 23px">
                    Vue.Js
                  </p>
                </v-flex>
                <v-flex xs6 sm3 md3>
                  <v-img
                    width="133px"
                    src="./assets/firebase.png"
                    style="margin-top: 0px"
                  ></v-img>
                  <p style="font-size: 20px; color: white; margin-top: 20px">
                    Firebase
                  </p>
                </v-flex>
                <v-flex xs6 sm3 md3>
                  <v-img
                    width="110px"
                    src="./assets/html.png"
                    style="margin-top: 0px"
                  ></v-img>
                  <p style="font-size: 20px; color: white; margin-top: 23px">
                    HTML
                  </p>
                </v-flex>
                <v-flex xs6 sm3 md3>
                  <v-img
                    width="110px"
                    src="./assets/sql.png"
                    style="margin-top: 0px"
                  ></v-img>
                  <p style="font-size: 20px; color: white; margin-top: 30px">
                    SQL
                  </p>
                </v-flex>
                <v-flex xs6 sm3 md3>
                  <v-img
                    width="110px"
                    src="./assets/reactnative.png"
                    style="margin-top: 0px"
                  ></v-img>
                  <p style="font-size: 20px; color: white; margin-top: 30px">
                    React Native
                  </p>
                </v-flex>
                <v-flex xs6 sm3 md3>
                  <v-img
                    width="110px"
                    src="./assets/php.png"
                    style="margin-top: 35px"
                  ></v-img>
                  <p style="font-size: 20px; color: white; margin-top: 45px">
                    PHP
                  </p>
                </v-flex>
                <v-flex xs6 sm3 md3>
                  <v-img
                    width="110px"
                    src="./assets/shopify.png"
                    style="margin-top: 0px"
                  ></v-img>
                  <p style="font-size: 20px; color: white; margin-top: 17px">
                    Shopify
                  </p>
                </v-flex>
                <v-flex xs6 sm3 md3>
                  <v-img
                    width="120px"
                    src="./assets/figma.png"
                    style="margin-top: 0px"
                  ></v-img>
                  <p style="font-size: 20px; color: white; margin-top: 17px">
                    Figma
                  </p>
                </v-flex>
              </v-row>
            </v-container>
          </v-card>
          <div
            class="display-2 font-weight-bold mb-3"
            align="center"
            style="margin-top: 50px"
          >
            <v-btn fab class="text-center" @click="$vuetify.goTo('#mywebwork')">
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </v-parallax>
      </section>

      <section id="mywebwork">
        <div class="py-1"></div>

        <v-container class="text-center">
          <h2 class="mb-3">
            WEB APPLICATION PROJECTS
          </h2>

          <v-card
            flat
            class="py-4"
            align="center"
            style="background-color: #1d2d44;"
          >
            <v-theme-provider>
              <div>
                <v-row align="center" justify="center">
                  <v-flex
                    xs12
                    sm6
                    md6
                    style="padding-left: 5px; padding-right: 5px; margin-bottom: 10px;"
                  >
                    <v-card height="400px">
                      <v-card-text>
                        <div>
                          <v-img
                            width="180px"
                            src="./assets/JewelsFiji.png"
                          ></v-img>
                        </div>
                        <br />
                        <div>
                          <span
                            max-width="720"
                            style="
                              font-size: 20px;
                              font-weight: bold;
                              color: black;
                            "
                            >Jewels Fiji</span
                          >
                          <br />
                          <div style="  text-align: justify;">
                            Jewels Fiji is a e-commerce website built on
                            Shopify. The store retails fine jewellery Fiji.
                          </div>
                        </div>
                        <v-btn
                          fab
                          text
                          small
                          a
                          href="https://jewelsfiji.com"
                          target="_blank"
                        >
                          <v-icon>mdi-link</v-icon>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                    style="padding-left: 5px; padding-right: 5px; margin-bottom: 10px;"
                  >
                    <v-card height="400px">
                      <v-card-text>
                        <div>
                          <v-img
                            width="180px"
                            src="./assets/Choca Mocha.png"
                          ></v-img>
                        </div>
                        <br />
                        <div>
                          <span
                            max-width="720"
                            style="
                              font-size: 20px;
                              font-weight: bold;
                              color: black;
                            "
                            >Choca Mocha</span
                          >
                          <br />
                          <div style="  text-align: justify;">
                            Choca Mocha is a website for a new coffee house
                            bistro operating in Fiji. This website is intended
                            to create a company's presence and provide
                            information to potential customers.
                          </div>
                        </div>
                        <v-btn
                          fab
                          text
                          small
                          a
                          href="https://chocamochafiji.com"
                          target="_blank"
                        >
                          <v-icon>mdi-link</v-icon>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                    style="padding-left: 5px; padding-right: 5px; margin-bottom: 10px;"
                  >
                    <v-card height="400px">
                      <v-card-text>
                        <div>
                          <v-img
                            width="180px"
                            src="./assets/Wai View 2.png"
                          ></v-img>
                        </div>
                        <br />
                        <div>
                          <span
                            max-width="720"
                            style="
                              font-size: 20px;
                              font-weight: bold;
                              color: black;
                            "
                            >Wai View Apartment</span
                          >
                          <br />
                          <div style="  text-align: justify;">
                            Wai View Apartment is a luxurious and modern
                            apartment complex located in a prime location with
                            breathtaking views of the surrounding landscape in
                            Savusavu, Fiji. This website is intended to create a
                            company's presence and provide information to
                            potential customers.
                          </div>
                        </div>
                        <v-btn
                          fab
                          text
                          small
                          a
                          href="https://waiview.web.app/"
                          target="_blank"
                        >
                          <v-icon>mdi-link</v-icon>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex
                    xs12
                    sm6
                    md6
                    style="padding-left: 5px; padding-right: 5px; margin-bottom: 10px;"
                  >
                    <v-card height="400px">
                      <v-card-text>
                        <div>
                          <v-img width="180px" src="./assets/e.png"></v-img>
                        </div>
                        <br />
                        <div>
                          <span
                            max-width="720"
                            style="
                              font-size: 20px;
                              font-weight: bold;
                              color: black;
                            "
                            >EZLINKING</span
                          >
                          <br />
                          <div style="  text-align: justify;">
                            EZLINKING is a web 2.0 application where users can
                            utilise the web application to create Digital
                            Contact Card and display all their content links and
                            contact information using one public URL. Profile
                            Links, Content and Digital Contact Card colours can
                            be added and managed based on the user's preference.
                          </div>
                        </div>
                        <v-btn
                          fab
                          text
                          small
                          a
                          href="https://ezlinking.net"
                          target="_blank"
                        >
                          <v-icon>mdi-link</v-icon>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md="6"
                    style="padding-left: 5px; padding-right: 5px; margin-bottom: 10px;"
                  >
                    <v-card height="400px">
                      <v-card-text>
                        <div>
                          <v-img
                            width="180px"
                            src="./assets/alfLogo.png"
                          ></v-img>
                        </div>
                        <br />
                        <div>
                          <span
                            max-width="720"
                            style="
                              font-size: 20px;
                              font-weight: bold;
                              color: black;
                            "
                            >International Airport</span
                          >
                          <br />
                          <div style="  text-align: justify;">
                            International Airport is a template airport website.
                            This website was developed using Vue.Js and Vuetify
                            and hosted on Firebase. The website has real-world
                            workings, such as flight searches and flight
                            schedules and providing airport information to the
                            users.
                          </div>
                        </div>
                        <v-btn
                          fab
                          text
                          small
                          a
                          href="https://nadiinternationalairport.web.app"
                          target="_blank"
                        >
                          <v-icon>mdi-link</v-icon>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                    style="padding-left: 5px; padding-right: 5px; margin-bottom: 10px;"
                  >
                    <v-card height="400px">
                      <v-card-text>
                        <div>
                          <v-img
                            width="180px"
                            src="./assets/BSA logo new.png"
                          ></v-img>
                        </div>
                        <br />
                        <div>
                          <span
                            max-width="720"
                            style="
                              font-size: 20px;
                              font-weight: bold;
                              color: black;
                            "
                            >Babu Singh & Associates</span
                          >
                          <br />
                          <div style="  text-align: justify;">
                            Babu Singh & Associates is a law firm based in Nadi,
                            Fiji. The website was developed to better inform the
                            interested public of the law firm's services being
                            provided.
                          </div>
                        </div>
                        <v-btn
                          fab
                          text
                          small
                          a
                          href="https://babusingh.com"
                          target="_blank"
                        >
                          <v-icon>mdi-link</v-icon>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-row>
              </div>
            </v-theme-provider>
            <br />
            <br />
            <v-btn
              class="align-self-end"
              fab
              outlined
              color="white"
              @click="$vuetify.goTo('#myappwork')"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </v-card>
        </v-container>

        <div class="py-1"></div>
      </section>

      <section id="myappwork">
        <div class="py-1"></div>

        <v-container class="text-center">
          <h2 class="mb-3">MOBILE APP PROJECTS</h2>

          <v-card
            class="py-4"
            flat
            align="center"
            style="background-color: #f0ebd8"
          >
            <v-theme-provider>
              <div>
                <v-row align="center" justify="center">
                  <v-flex
                    xs12
                    sm6
                    md6
                    style="padding-left: 5px; padding-right: 5px; margin-bottom: 10px;"
                  >
                    <v-card height="450px">
                      <v-card-text>
                        <div>
                          <v-img
                            width="180px"
                            src="./assets/shoppingapp.png"
                          ></v-img>
                        </div>
                        <br />
                        <div>
                          <span
                            max-width="720"
                            style="
                              font-size: 20px;
                              font-weight: bold;
                              color: black;
                            "
                            >Shopping List</span
                          >
                          <br />
                          <div style="  text-align: justify;">
                            Shopping List mobile application is an easy to use
                            list idea, which replaces the traditional pen and
                            paper shopping list. You can manage your personal
                            shopping list and you can also share a shopping with
                            another person. Firebase is used for realtime
                            storage technology and authentication. The
                            application is free to download. Download link
                            below.
                          </div>
                        </div>
                        <v-btn
                          fab
                          text
                          small
                          a
                          href="https://drive.google.com/file/d/1xLeOQ6WX05TMNYrSAvOVgAFgUtqDWdg-/view?usp=sharing"
                          target="_blank"
                        >
                          <v-icon>mdi-android</v-icon>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-row>
              </div>
            </v-theme-provider>
            <br />
            <br />
            <v-btn
              class="align-self-end"
              fab
              outlined
              @click="$vuetify.goTo('#contact')"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </v-card>
        </v-container>

        <div class="py-1"></div>
      </section>

      <v-sheet id="contact" color="#333333" dark tag="section" tile>
        <div class="py-1"></div>
        <v-container class="text-center">
          <h2 class="mb-3 text-center">
            Have a project idea? Contact me
          </h2>

          <v-card
            id="saying"
            tile
            align="center"
            class="mx-auto"
            max-width="100%"
          >
            <v-card-text>
              <v-row
                ><v-col>
                  <div id="saying" class="py-12  ">
                    <v-btn fab light>
                      <v-icon large @click="submit()">mdi-email</v-icon></v-btn
                    >
                    <span
                      @click="submit()"
                      style="color:#02c39a;font-weight:bold;cursor: pointer; font-size: 18px; "
                    >
                      shamalkumardeveloper@gmail.com</span
                    >
                  </div>
                </v-col> </v-row
              ><br />
            </v-card-text>
          </v-card>
          <!-- <v-theme-provider light> -->
          <!-- <form
              action="https://formsubmit.co/86f5c52d02556370541de4990590abfe"
              method="POST"
            > -->
          <!-- <form>
              <v-row align="center" justify="center">
                <v-col cols="12">
                  <v-text-field
                    flat
                    label="Name*"
                    name="name"
                    solo
                    class="form-control"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    flat
                    label="Email*"
                    type="email"
                    name="email"
                    solo
                    class="form-control"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    flat
                    label="Subject*"
                    name="subject"
                    solo
                    class="form-control"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    flat
                    label="Message*"
                    name="message"
                    solo
                    class="form-control"
                  ></v-textarea>
                </v-col>

                <v-col class="mx-auto" cols="auto">
                  <v-btn color="primary" x-large type="submit">Submit</v-btn>
                </v-col>
              </v-row>
            </form> -->
          <!-- </v-theme-provider> -->
        </v-container>

        <div class="py-6"></div>
      </v-sheet>
    </v-main>

    <v-footer class="justify-center" color="#292929" height="100"
      ><img src="../public/2.png" width="60px" style="margin-top: 0px;" />
      <div
        class="title font-weight-light grey--text text--lighten-1 text-center"
      >
        {{ new Date().getFullYear() }} Shamal Kumar
      </div>
    </v-footer>
  </v-app>
</template>
<script>
export default {
  data() {
    return {
      name: null,
      email: null,
      subject: null,
      message: null,
    };
  },
  methods: {
    submit() {
      window.location.href = "mailto:shamalkumardeveloper@gmail.com";
    },
  },
};
</script>
<style>
#app {
  font-family: "Jost", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  background-color: white;
}
#saying {
  color: white;
  font-size: 20px;
  background-color: #0c1c24;
}
#header1 {
  font-family: "Jost", sans-serif;
  font-size: 30px;
  font-weight: 500;
  position: relative;
  bottom: -10px;
  color: #003566;
  padding-left: 5px;
}
#about-me {
  color: white;
  background-color: #034078;
}
#workwith {
  color: white;
  background-color: #001427;
}
#mywebwork {
  color: white;
  background-color: #1d2d44;
}
#myappwork {
  color: black;
  background-color: #f0ebd8;
}
h2 {
  font-family: "Jost", sans-serif;
  font-size: 30px;
}
</style>
